import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, ShieldIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const AlloyGatorPage = () => {
  return <main data-id="element-696">
      <SEO title="AlloyGator Almere | Velgbescherming | BKCustoms" description="Bescherm uw velgen in Almere tegen stoepschade met AlloyGator wielkastbeschermers. Professionele installatie door BKCustoms. Duurzaam en verkrijgbaar in meerdere kleuren." canonical="/diensten/alloygator" data-id="element-697" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-698">
        <div className="absolute inset-0 overflow-hidden" data-id="element-699">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-700"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d9Rkg47SKWSVtxvpKhbWvX/1_%281%29.jpg" alt="AlloyGator in Almere" className="w-full h-full object-cover object-center" data-id="element-701" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-702">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-703">
            <span className="text-[#D6281F]" data-id="element-704">AlloyGator Almere</span> - Bescherm
            uw velgen
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-705">
            Premium bescherming voor uw velgen tegen schade van stoepranden met
            onze hoogwaardige AlloyGator wielkastbeschermers in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-706">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-707">
              <span className="mr-2" data-id="element-708">Direct afspraak maken</span>
              <ArrowRightIcon size={16} data-id="element-709" />
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-710">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-711">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-712">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-713">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-714">
              <div className="relative" data-id="element-715">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-716"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-717">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d9Rkg47SKWSVtxvpKhbWvX/1_%281%29.jpg" alt="AlloyGator wielkastbeschermer in Almere" className="w-full h-auto object-cover" data-id="element-718" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-719">
              <div className="flex items-center mb-6" data-id="element-720">
                <div className="bg-[#D6281F]/20 p-2 rounded-full mr-4" data-id="element-721">
                  <ShieldIcon size={28} className="text-[#D6281F]" data-id="element-722" />
                </div>
                <div className="h-px flex-grow bg-gradient-to-r from-[#D6281F] to-transparent" data-id="element-723"></div>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-724">
                AlloyGator Velgbescherming in Almere
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-725">
                AlloyGator is de ultieme bescherming voor uw voertuig in Almere!
                Onze hoogwaardige wielkastbeschermers zijn gemaakt van een
                duurzaam en flexibel materiaal dat uw velgen beschermt tegen
                stoepschade, steenslag en andere beschadigingen.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-726">
                Dankzij de eenvoudige installatie door onze specialisten in
                Almere en het strakke design is AlloyGator de perfecte keuze
                voor elke autoliefhebber die zijn velgen in topconditie wil
                houden.
              </p>
              <div className="space-y-4 mb-8" data-id="element-727">
                <div className="flex items-center" data-id="element-728">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-729"></div>
                  <span className="text-white/90" data-id="element-730">
                    Beschermt tegen stoepschade en steenslag
                  </span>
                </div>
                <div className="flex items-center" data-id="element-731">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-732"></div>
                  <span className="text-white/90" data-id="element-733">
                    Verkrijgbaar in verschillende kleuren
                  </span>
                </div>
                <div className="flex items-center" data-id="element-734">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-735"></div>
                  <span className="text-white/90" data-id="element-736">
                    Professionele installatie door BKCustoms in Almere
                  </span>
                </div>
                <div className="flex items-center" data-id="element-737">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-738"></div>
                  <span className="text-white/90" data-id="element-739">
                    Duurzaam en weerbestendig materiaal
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-740">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-741">
                  <span className="mr-2" data-id="element-742">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-743" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-744">
                  Offerte aanvragen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-745">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-746">
          <div className="text-center mb-16" data-id="element-747">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-748">
              De <span className="text-[#D6281F]" data-id="element-749">Voordelen</span> van
              AlloyGator in Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-750">
              Ontdek waarom AlloyGator de beste keuze is voor velgbescherming in
              Almere.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-751">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-752">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-753">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-754" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-755">
                Optimale Bescherming
              </h3>
              <p className="text-white/80" data-id="element-756">
                AlloyGator biedt superieure bescherming tegen stoepschade,
                steenslag en andere alledaagse gevaren die uw velgen kunnen
                beschadigen.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-757">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-758">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-759" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-760">
                Kostenbesparend
              </h3>
              <p className="text-white/80" data-id="element-761">
                Voorkom dure reparaties of vervanging van beschadigde velgen.
                AlloyGator is een eenmalige investering die u op lange termijn
                geld bespaart.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-762">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-763">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-764" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-765">
                Esthetisch Aantrekkelijk
              </h3>
              <p className="text-white/80" data-id="element-766">
                Verkrijgbaar in verschillende kleuren om te matchen of juist te
                contrasteren met uw voertuig, voor een gepersonaliseerde look.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Color Options Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-767">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-768">
          <div className="text-center mb-16" data-id="element-769">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-770">
              Beschikbare <span className="text-[#D6281F]" data-id="element-771">Kleuren</span> in
              Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-772">
              Kies uit onze selectie kleuren om uw AlloyGator te personaliseren
              bij BKCustoms in Almere.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4" data-id="element-773">
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-774">
              <div className="w-full aspect-square rounded-md bg-[#000000] mb-3" data-id="element-775"></div>
              <span className="text-white font-medium" data-id="element-776">Zwart</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-777">
              <div className="w-full aspect-square rounded-md bg-[#FF0000] mb-3" data-id="element-778"></div>
              <span className="text-white font-medium" data-id="element-779">Rood</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-780">
              <div className="w-full aspect-square rounded-md bg-[#0000FF] mb-3" data-id="element-781"></div>
              <span className="text-white font-medium" data-id="element-782">Blauw</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-783">
              <div className="w-full aspect-square rounded-md bg-[#FFFF00] mb-3" data-id="element-784"></div>
              <span className="text-white font-medium" data-id="element-785">Geel</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-786">
              <div className="w-full aspect-square rounded-md bg-[#00FF00] mb-3" data-id="element-787"></div>
              <span className="text-white font-medium" data-id="element-788">Groen</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-789">
              <div className="w-full aspect-square rounded-md bg-[#FFA500] mb-3" data-id="element-790"></div>
              <span className="text-white font-medium" data-id="element-791">Oranje</span>
            </div>
          </div>
          <p className="text-white/60 text-center mt-6" data-id="element-792">
            * Meer kleuren beschikbaar op aanvraag
          </p>
        </div>
      </section>
      {/* Installation Process Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-793">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-794">
          <div className="text-center mb-16" data-id="element-795">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-796">
              Installatie <span className="text-[#D6281F]" data-id="element-797">Proces</span> in
              Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-798">
              Bij BKCustoms in Almere volgen we een zorgvuldig proces om uw
              AlloyGator perfect te installeren.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-799">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-800">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-801">
                1
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-802">
                Voorbereiding
              </h3>
              <p className="text-white/80" data-id="element-803">
                We reinigen uw velgen grondig en controleren op eventuele
                bestaande schade die moet worden gerepareerd voordat de
                AlloyGator wordt geïnstalleerd.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-804">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-805">
                2
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-806">
                Installatie
              </h3>
              <p className="text-white/80" data-id="element-807">
                Onze specialisten in Almere installeren de AlloyGator zorgvuldig
                tussen de velg en de band, waarbij ze zorgen voor een perfecte
                pasvorm en afwerking.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-808">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-809">
                3
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-810">
                Afwerking
              </h3>
              <p className="text-white/80" data-id="element-811">
                Na installatie controleren we elke AlloyGator op correcte
                plaatsing en zorgen we ervoor dat uw velgen er perfect uitzien
                met hun nieuwe bescherming.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-812">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-813">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-814">
            Bescherm uw velgen vandaag nog in Almere!
          </h2>
          <p className="text-white/80 mb-8" data-id="element-815">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto bij BKCustoms in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-816">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-817">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-818">
              Contact opnemen
            </Link>
          </div>
        </div>
      </section>
    </main>;
};